import React, { useState, useEffect } from "react"

import KwikLogo from "../../assets/images/kwik_white_bg.png"
import InstantVoiceLogo from "../../assets/images/instant-voice-logo.png"
import CortexLogo from "../../assets/images/cortex-logo-horizontal.png"
import ScoutLogo from "../../assets/images/kwik-scout-logo.png"

import useNotification from "../Notification"
import { useMenu } from "../../contexts/MenuContext"

import dayjs from "dayjs"
import api from "../../api"

import "./styles.css"

const products = [
    {
        name: "Kwik",
        description:
            "Omnichannel, CRM, campanhas, automações e gestão de relacionamento em uma única plataforma.",
        icon: KwikLogo,
        iconWidth: 90,
        iconHeight: 90,
        url: "https://landing.kwik.app.br/"
    },
    {
        name: "InstantVoice",
        description:
            "PABX, contact center, URA, gravação, discador e relatórios integrados à operação.",
        icon: InstantVoiceLogo,
        iconWidth: 60,
        iconHeight: 60,
        url: "https://landing.instant.com.br/instant-cloud-voice/"
    },
    {
        name: "Kwik Scout",
        description:
            "Visibilidade, auditoria, histórico corporativo e governança sobre conversas de WhatsApp.",
        icon: ScoutLogo,
        iconWidth: 125,
        iconHeight: 60,
        url: "https://scout.kwik.app.br/"
    },
    {
        name: "Cortex",
        description:
            "IA generativa aplicada ao atendimento, suporte, vendas, análise e automação de processos.",
        icon: CortexLogo,
        iconWidth: 100,
        iconHeight: 100,
        url: "https://cortex.instant.com.br/"
    },
]

const quickLinks = [
    {
        title: "Blog e conteúdos",
        description: "Artigos, guias e materiais",
        icon: "📰",
        url: "https://www.instant.com.br/blog/"
    },
    {
        title: "Changelog",
        description: "Novidades e melhorias do produto",
        icon: "✦",
        url: "https://docs.google.com/document/d/1W51K4OYUjmRzcJN2UIeUoV6CflPVY73xjc97_9qxJj4/edit?usp=sharing"
    },
    {
        title: "Webinars e vídeos",
        description: "Demonstrações e boas práticas",
        icon: "▶",
        url: "https://www.youtube.com/@br.instant"
    },
    {
        title: "Fale com um especialista",
        description: "Entre em contato com nossa equipe",
        icon: "💬",
        url: "https://solucoes.instant.com.br/agendamento/"
    },
]

function Portal() {

    const { configurableUrls } = useMenu()

    const [hero, setHero] = useState({})
    const [featuredContent, setFeaturedContent] = useState([])
    const [updates, setUpdates] = useState([])
    const [ideas, setIdeas] = useState([])

    const [newIdea, setNewIdea] = useState({
        category: "",
        title: "",
        description: "",
        email: "",
    });

    useEffect(() => {
        const load = async () => {
            const response = await api.get("api/portal/")
            if (response.status === 200) {
                setHero(response.data.hero)
                setFeaturedContent(response.data.featured)
                setUpdates(response.data.updates)
                setIdeas(response.data.ideas)
            }
        }
        load()
    }, [])

    const handleIdeaFeedback = async (ideaId, feedbackType) => {
        try {
            const response = await api.post(
                `/api/portal/${ideaId}/feedback/`,
                {
                    feedback_type: feedbackType,
                }
            )

            if (response.status === 200) {
                setIdeas((currentIdeas) =>
                    currentIdeas.map((idea) =>
                        idea.id === ideaId
                            ? {
                                ...idea,
                                user_feedback: feedbackType,
                            }
                            : idea
                    )
                )

                useNotification(
                    "Sucesso",
                    "Obrigado pelo seu feedback.",
                    "success"
                )
            }
        } catch (error) {
            console.error("Erro ao registrar feedback da ideia:", error)
        }
    }
    
    const handleNewIdea = async () => {
        try {
            const response = await api.post("/api/portal/new_idea/", {
                category: newIdea.category,
                title: newIdea.title,
                description: newIdea.description,
                email: newIdea.email,
            })

            if (response.status === 200) {
                setNewIdea({
                    category: "",
                    title: "",
                    description: "",
                    email: "",
                })

                useNotification(
                    "Sucesso",
                    "Sua sugestão foi registrada com sucesso, obrigado.",
                    "success"
                )
            }
        } catch (error) {
            console.error("Erro ao enviar ideia:", error);
        }
    }

    return (
        <div className="portal-page">
            <main className="portal-content">

                <section className="top-layout">
                    <section className="hero-section">
                        <div className="hero-content">
                            <span className="hero-label">DESTAQUE DO MÊS</span>
                            <h1>{hero.title}</h1>
                            <p>{hero.subtitle}</p>
                            <button
                                className="primary-button"
                                onClick={() => window.open(
                                    hero.url, 
                                    "_blank", 
                                    "noopener,noreferrer"
                                )}
                            >
                                Conheça as novidades
                            </button>
                        </div>
                        <div className="hero-decoration">
                            <div className="hero-circle hero-circle-1" />
                            <div className="hero-circle hero-circle-2" />
                            <div className="hero-orbit">
                                <span>✦</span>
                            </div>
                        </div>
                    </section>

                    <section className="quick-access-section">
                        <SectionHeader eyebrow="ACESSO RÁPIDO" />
                        <div className="quick-links-grid">
                            {quickLinks.map((link) => (
                                <a 
                                    className="quick-link-card"
                                    key={link.title}
                                    href={(link.title === "Fale com um especialista" && configurableUrls?.agendamento)
                                        ? configurableUrls.agendamento
                                        : link.url
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <div className="quick-link-icon">
                                        {link.icon}
                                    </div>
                                    <div className="quick-link-info">
                                        <h3>{link.title}</h3>
                                        <p>{link.description}</p>
                                    </div>
                                    <span className="arrow">→</span>
                                </a>
                            ))}
                        </div>
                    </section>
                </section>

                <section className="section ecosystem-section">
                    <SectionHeader eyebrow="ECOSSISTEMA INSTANT" />
                    <div className="products-grid">
                        {products.map((product) => (
                            <a
                                className="product-card"
                                key={product.name}
                                // href={(product.name === "Kwik Scout" && configurableUrls?.scout)
                                //     ? configurableUrls.scout
                                //     : (product.name === "Cortex" && configurableUrls?.cortex)
                                //         ? configurableUrls.cortex
                                //         : (product.name === "InstantVoice" && configurableUrls?.telefonia)
                                //             ? configurableUrls.telefonia
                                //             : (product.name === "Kwik" && configurableUrls?.atendimento)
                                //                 ? configurableUrls.atendimento
                                //                 : product.url
                                // }
                                href={product.url}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <div className="product-icon">
                                    {typeof product.icon === "string" &&
                                    (
                                        product.icon.endsWith(".png") ||
                                        product.icon.startsWith("data:image/")
                                    ) ? (
                                        <img
                                            src={product.icon}
                                            alt={`${product.name} logo`}
                                            style={{
                                                width: product.iconWidth,
                                                height: product.iconHeight,
                                            }}
                                        />
                                    ) : (
                                        product.icon
                                    )}
                                </div>
                                <div className="product-info">
                                    <p>{product.description}</p>
                                </div>
                                <span className="product-arrow">
                                    Conheça o {product.name} →
                                </span>
                            </a>
                        ))}
                    </div>
                </section>

                <section className="section">
                    <SectionHeader eyebrow="CONTEÚDOS EM DESTAQUE" />
                    <div className="featured-layout">
                        <div className="featured-grid">
                            {featuredContent.slice(0, 3).map((content) => (
                                <a
                                    className="content-card"
                                    key={content.id}
                                    href={content.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <div className="content-icon">
                                        {content.icon}
                                    </div>
                                    <div className="content-body">
                                        <div className="content-meta">
                                            <span className="eyebrow">
                                                {content.content_type}
                                            </span>
                                            <small>
                                                {dayjs(content.created_at).format("DD/MM/YYYY")}
                                            </small>
                                        </div>
                                        <h3>{content.title}</h3>
                                        <p>{content.description}</p>
                                    </div>
                                    <span className="content-link">
                                        Ler artigo →
                                    </span>
                                </a>
                            ))}
                        </div>

                        <aside className="side-cards">
                            <a
                                className="side-feature changelog-card"
                                href="https://docs.google.com/document/d/1W51K4OYUjmRzcJN2UIeUoV6CflPVY73xjc97_9qxJj4/edit?usp=sharing"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <p className="eyebrow">PRODUTO EM EVOLUÇÃO</p>
                                <h3>Acompanhe as novidades do Kwik</h3>
                                <p>Veja todas as novidades e melhorias recentes dos nossos produtos.</p>
                                <span>Acessar changelog →</span>
                            </a>

                            <a
                                className="side-feature webinar-card"
                                href="https://www.youtube.com/@br.instant"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <p className="eyebrow">CONTEÚDO RECOMENDADO</p>
                                <h3>Próximo Webinar</h3>
                                <p>Veja como integrar atendimento, telefonia, WhatsApp e IA em uma única estratégia operacional.</p>
                                <span>Ver programação →</span>
                            </a>
                        </aside>
                    </div>
                </section>

                <section className="section">
                    <SectionHeader eyebrow="ÚLTIMAS ATUALIZAÇÕES" />
                    <div className="updates-card">
                        {updates.slice(0, 3).map((update) => (
                            <article className="update-row" key={update.id}>
                                <div className="update-marker"><span /></div>

                                <div className="update-content">
                                    <div className="update-meta">
                                        <span className="update-type">
                                            {update.update_label}
                                        </span>
                                        <time>
                                            {dayjs(update.created_at).format("DD/MM/YYYY")}
                                        </time>
                                    </div>

                                    <h3>{update.title}</h3>
                                    <p>{update.description}</p>
                                </div>
                            </article>
                        ))}
                    </div>
                </section>

                <section className="section">
                    <SectionHeader eyebrow="AMBIENTE DE INOVAÇÃO" />
                    <section className="innovation-layout">
                        <section className="innovation-section">
                            <div className="innovation-header">
                                <div>
                                    <h2>Escuta ativa com clientes</h2>
                                    <p>Compartilhe ideias, vote nas sugestões da comunidade e ajude a construir o futuro dos nossos produtos.</p>
                                </div>

                                <div className="innovation-symbol">💡</div>
                            </div>

                            <div className="ideas-list">
                                {ideas.slice(0, 3).map((idea) => {
                                    return (
                                        <article className="idea-card" key={idea.id}>
                                            <div className="idea-content">
                                                <div className="idea-main">
                                                    <div className="idea-category">
                                                        {idea.category_label}
                                                    </div>
                                                    
                                                    <h3>{idea.title}</h3>
                                                    <p>{idea.description}</p>
                                                    
                                                    <div className="idea-actions">
                                                        <button
                                                            className={`idea-action interested ${
                                                                idea.user_feedback === "interested" ? "selected" : ""
                                                            }`}
                                                            onClick={() => handleIdeaFeedback(idea.id, "interested")}
                                                        >
                                                            Tenho interesse
                                                        </button>

                                                        <button
                                                            className={`idea-action not-sure ${
                                                                idea.user_feedback === "want_to_know_more" ? "selected" : ""
                                                            }`}
                                                            onClick={() => handleIdeaFeedback(idea.id, "want_to_know_more")}
                                                        >
                                                            Quero saber mais
                                                        </button>

                                                        <button
                                                            className={`idea-action not-interested ${
                                                                idea.user_feedback === "not_interested" ? "selected" : ""
                                                            }`}
                                                            onClick={() => handleIdeaFeedback(idea.id, "not_interested")}
                                                        >
                                                            Não usaria
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </article>
                                    )
                                })}
                            </div>
                        </section>

                        <section className="new-idea-section">
                            <div className="new-idea-content">
                                <h2>Tem uma nova ideia?</h2>
                                <p>Ajude a melhorar nossos produtos e nossa experiência compartilhando uma sugestão.</p>

                                <div className="idea-form">
                                    <div className="form-field">
                                        <label htmlFor="idea-topic">Tema *</label>

                                        <select
                                            id="idea-topic"
                                            className="idea-input"
                                            value={newIdea.category}
                                            onChange={(event) => setNewIdea((current) => ({
                                                ...current,
                                                category: event.target.value
                                            }))}
                                        >
                                            <option value="">Selecione um tema</option>
                                            <option value="Produto">Produto</option>
                                            <option value="Atendimento">Atendimento</option>
                                            <option value="Experiencia">Experiência</option>
                                            <option value="Outro">Outro</option>
                                        </select>
                                    </div>

                                    <div className="form-field">
                                        <label htmlFor="idea-title">Título *</label>

                                        <input
                                            id="idea-title"
                                            type="text"
                                            className="idea-input"
                                            placeholder="Dê um título para sua ideia"
                                            value={newIdea.title}
                                            onChange={(event) => setNewIdea((current) => ({
                                                ...current,
                                                title: event.target.value
                                            }))}
                                        />
                                    </div>

                                    <div className="form-field">
                                        <label htmlFor="idea-description">Descrição *</label>

                                        <textarea
                                            id="idea-description"
                                            className="idea-textarea"
                                            placeholder="Conte mais sobre sua ideia..."
                                            rows={5}
                                            value={newIdea.description}
                                            onChange={(event) => setNewIdea((current) => ({
                                                ...current,
                                                description: event.target.value
                                            }))}
                                        />
                                    </div>

                                    <div className="form-field">
                                        <label htmlFor="idea-email">E-mail</label>

                                        <input
                                            id="idea-email"
                                            type="email"
                                            className="idea-input"
                                            placeholder="seu@email.com"
                                            value={newIdea.email}
                                            onChange={(event) => setNewIdea((current) => ({
                                                ...current,
                                                email: event.target.value
                                            }))}
                                        />

                                        <span className="form-help">
                                            Deseja ser contactado sobre sua ideia?
                                        </span>
                                    </div>

                                    <div className="idea-form-actions">
                                        <button
                                            type="button"
                                            className="primary-button"
                                            onClick={() => handleNewIdea()}
                                            disabled={!newIdea.category || !newIdea.title || !newIdea.description}
                                        >
                                            Enviar ideia
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </section>
                </section>
            </main>
        </div>
    )
}

function SectionHeader({
    eyebrow,
    title,
    description,
    action,
}) {
    return (
        <div className="section-header">

            <div>

                <span className="section-eyebrow">
                    {eyebrow}
                </span>

                <h2>
                    {title}
                </h2>

                {description && (
                    <p>
                        {description}
                    </p>
                )}

            </div>

            {action && (
                <a
                    href="#"
                    className="section-action"
                >
                    {action} →
                </a>
            )}

        </div>
    )
}

export default Portal